import * as types from './mutations_types.js'
export default {
  SET_TOKEN: ({commit}, token) => commit(types.SET_TOKEN, token),
  LOGIN: ({commit}, param) => commit(types.LOGIN, {data: param}),
  LOGOUT: ({commit}) => commit(types.LOGOUT),
  SET_NEWS: ({commit}, news) => commit(types.SET_NEWS, news),
  SET_SLIDE: ({commit}, slide) => commit(types.SET_SLIDE, slide),
  SET_COMPANIES: ({commit}, companies) => commit(types.SET_COMPANIES, companies),
  UPDATEUSER: ({commit}, param) => commit(types.UPDATEUSER, {data: param}),
  CLEAR_FIRST_BUY: ({commit}, param) => commit(types.CLEAR_FIRST_BUY, {data: param})
}



// WEBPACK FOOTER //
// ./src/store/home/actions.js